import { Col, Container, Row } from "react-bootstrap";
import { SkeletonBox } from "../../components/skeleton-box";

export default function SubscribeSkeletonLoader() {
    return (
        <Container className="mt-2">
            <Row>
                <Col
                    xs={{ span: 12 }}
                    md={{ span: 10, offset: 1 }}
                    lg={{ span: 10, offset: 1 }}
                    className="d-flex flex-column bg-white border rounded p-3 payment-wrapper"
                >
                    <Col className="pt-3">
                        <SkeletonBox
                            style={{ width: "300px", height: "30px" }}
                        />
                    </Col>
                    <Col>
                        <SkeletonBox
                            style={{ width: "100%", height: "15px" }}
                        />
                    </Col>
                    <Col className="my-3">
                        <SkeletonBox
                            style={{ width: "200px", height: "20px" }}
                        />
                    </Col>
                    <Col>
                        <SkeletonBox
                            style={{ width: "100%", height: "300px" }}
                        />
                    </Col>
                    <Col className="d-flex flex-column justify-content-center align-items-center mt-3 gap-2">
                        <SkeletonBox
                            style={{ width: "200px", height: "30px" }}
                        />
                        <SkeletonBox
                            style={{ width: "300px", height: "10px" }}
                        />
                    </Col>
                </Col>
            </Row>
        </Container>
    );
}
